

























import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import ProductList from '@/modules/product/components/ProductList.vue'
import * as api from '@/modules/product/api'
import {Product} from '@/modules/product';

/**
 * Dialogo de selección de productos
 *
 * Muestra al usuario una pantalla con la lista de productos de la tienda y barras de
 * búsqueda para filtrar por nombre y código de producto.
 *
 * Puede hacer click sobre las filas para seleccionar un producto.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        ProductList,
    },
})
export default class ProductListDialog extends Vue {
    @Prop({type: Boolean, default: true})
    public allowEdit: boolean

    @Prop({type: Boolean, default: true})
    public showLoadingScreen: boolean

    @Prop({type: Boolean, default: true})
    public allowSelect: boolean

    @Prop({type: Boolean, default: false})
    public value: boolean

    @Prop({type: String, default: ''})
    public productId: string

    /**
     * Valor interno que almacena el último producto seleccionado
     */
    public internalValue: Product | null = null

    @Watch('productId', {immediate: true})
    public async onProductIdChange (val: string) {
        if (!val || (this.internalValue && this.internalValue.id === val)) {
            return
        }

        this.$emit('select', await api.getProduct(val))
    }

    public onPagination () {
        document.getElementById('product-list-container')!.scrollTop = 0
    }

    /**
     * Selecciona un producto
     *
     * @param product
     */
    public selectProduct (product: Product) {
        this.internalValue = product
        this.$emit('select', product)
    }
}
